module.exports = __webpack_public_path__ + "img/relais-&-chateaux-food-for-change.193f16c8.jpg";